module.exports = __webpack_public_path__ + "img/upload-productos.ab161e36.png";